import axios from "axios";
import $ from "jquery";

const state = {
  landingPageStatistics: {},
  landingPage: {},
  publishedLandingPages: [],
  unpublishedLandingPages: [],
};

const getters = {
  landingPageStatistics(state) {
    return state.landingPageStatistics;
  },

  landingPage(state) {
    return state.landingPage;
  },

  publishedLandingPages(state) {
    return state.publishedLandingPages;
  },

  unpublishedLandingPages(state) {
    return state.unpublishedLandingPages;
  },
};

const mutations = {
  setLandingPageStatistics(state, statistics) {
    state.landingPageStatistics = statistics;
  },

  setLandingPage(state, page) {
    state.landingPage = page;
  },

  setPublishedLandingPages(state, pages) {
    state.publishedLandingPages = pages;
  },

  setUnpublishedLandingPages(state, pages) {
    state.unpublishedLandingPages = pages;
  },

  deletePublishedLandingPage(state, id) {
    let index = state.publishedLandingPages.findIndex((p) => p.id == id);
    state.publishedLandingPages.splice(index, 1);
  },

  deleteUnpublishedLandingPage(state, id) {
    let index = state.unpublishedLandingPages.findIndex((p) => p.id == id);
    state.unpublishedLandingPages.splice(index, 1);
  },
};

const actions = {
  async fetchLandingPageStatistics({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/landing-page/statistics`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setLandingPageStatistics", res.data);
      });
  },

  async fetchLandingPage({ commit, rootState }, id) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/landing-page/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setLandingPage", res.data);
      });
  },

  async fetchPublishedLandingPages({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/landing-page/published`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setPublishedLandingPages", res.data);
      });
  },

  async fetchUnpublishedLandingPages({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/landing-page/unpublished`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setUnpublishedLandingPages", res.data);
      });
  },

  async publishLandingPage({ commit, dispatch, rootState }, data) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .put(
        `${apiUrl}/landing-page/publish/update?id=${data.id}&publish=${data.publish}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(() => {
        dispatch("hideSpinnerLoading", null, { root: true });

        if (data.publish) {
          $.alert("page published successfull");
          commit("deleteUnpublishedLandingPage", data.id);
        } else {
          $.alert("page unpublished successfull");
          commit("deletePublishedLandingPage", data.id);
        }
      });
  },

  async createLandingPage({ rootState }, page) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/landing-page/create`, page, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async updateLandingPage({ rootState }, data) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.put(`${apiUrl}/landing-page/update/${data.id}`, data.page, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async deleteLandingPage({ dispatch, rootState }, id) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .delete(`${apiUrl}/landing-page/delete?id=${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(() => {
        $.alert("page deleted successfull");

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async uploadLandingPagePhoto({ rootState }, formData) {
    const accessToken = rootState.authStore.token;
    const apiUrl = process.env.VUE_APP_API_URL;

    return await axios.post(`${apiUrl}/landing-page/photo/upload`, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async deleteLandingPagePhoto({ rootState }, data) {
    const accessToken = rootState.authStore.token;
    const apiUrl = process.env.VUE_APP_API_URL;

    await axios
      .delete(`${apiUrl}/landing-page/photo/delete`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        data: data,
      })
      .then(() => {
        $.alert("Image deleted !");
      });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
